export const loomBrandingTheme = {
  colors: {
    main: '#565ADD',
    second: '#787BE4',
    white: '#FFFFFF',
  },
};
